function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 12L8.25 15H14.25C15.075 15 15.75 14.325 15.75 13.5C15.75 12.675 15.075 12 14.25 12H11.25Z",
  fill: "#727981"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.045 5.39258L2.4675 11.9701C2.3325 12.1051 2.25 12.3001 2.25 12.4951V14.2501C2.25 14.6626 2.5875 15.0001 3 15.0001H4.755C4.9575 15.0001 5.145 14.9176 5.2875 14.7826L11.865 8.20508L9.045 5.39258Z",
  fill: "#727981"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0327 6.02992C14.3252 5.73742 14.3252 5.26492 14.0327 4.97242L12.2777 3.21742C11.9852 2.92492 11.5127 2.92492 11.2202 3.21742L9.84766 4.58992L12.6602 7.40242L14.0327 6.02992Z",
  fill: "#727981"
});

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.80af68be.svg";
export { ForwardRef as ReactComponent };